import React, { type ReactNode } from 'react';

import StatusErrorIcon from '@atlaskit/icon/core/status-error';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const errorMessageWrapperStyles = xcss({
	display: 'flex',
	alignItems: 'flex-start',
	gap: 'space.050',
});

const errorMessageTextStyles = xcss({
	font: 'font.body.small',
	color: 'color.text.accent.red',
});

export const FormFieldErrorMessage = ({ children }: { children: ReactNode }): React.JSX.Element => (
	<Box xcss={errorMessageWrapperStyles}>
		<StatusErrorIcon label="" color={token('color.icon.accent.red')} />
		<Inline xcss={errorMessageTextStyles}>{children}</Inline>
	</Box>
);
